import { useState } from 'react';
import { useReactiveVar } from '@apollo/client';

import { didInfoVar } from '@store/index';

import { Wrapper } from '@components/styled/StyledComponents';
import Headline from '@components/layout/Headline';
import TabMenu from '@components/layout/TabMenu';
import BasicSetting from '@components/features/Setting/BasicSetting';
import Playlist from '@components/features/Setting/Playlist/Playlist';
import ImageSetting from '@components/features/Setting/ImageSetting/ImageSetting';
import VideoSetting from '@components/features/Setting/VideoSetting/VideoSetting';
import NoticeSetting from '@components/features/Setting/NoticeSetting/NoticeSetting';

const TAB_MENU = ['기본설정', '플레이리스트', '이미지 설정', '영상 설정'];

const EditEquipment = () => {
    const { version } = useReactiveVar(didInfoVar);
    const [selectedTab, setSelectedTab] = useState('기본설정');

    return (
        <Wrapper>
            <Headline
                title="DID 모니터 설정 변경"
                subTitle="모니터에 송출되는 공지사항·이미지·영상 설정 변경"
            />
            <TabMenu
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                options={
                    version === 1 ? [...TAB_MENU, '공지사항 설정'] : TAB_MENU
                }
            />
            {selectedTab === '기본설정' && <BasicSetting />}
            {selectedTab === '플레이리스트' && <Playlist />}
            {selectedTab === '이미지 설정' && <ImageSetting />}
            {selectedTab === '영상 설정' && <VideoSetting />}
            {selectedTab === '공지사항 설정' && <NoticeSetting />}
        </Wrapper>
    );
};

export default EditEquipment;
